import {Injectable} from '@angular/core';
import {IAPProduct, InAppPurchase2} from '@ionic-native/in-app-purchase-2/ngx';
import {MessageService} from '../message-service/message.service';
import {LoadingController, Platform, ToastController} from '@ionic/angular';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class IAPService {

    products: IAPProduct[] = [];
    ownedProducts: IAPProduct[] = [];
    loader: HTMLIonLoadingElement;

    constructor(private store: InAppPurchase2,
                private toastCtrl: ToastController,
                private loadingCtrl: LoadingController,
                private router: Router,
                private platform: Platform,
                private msgService: MessageService) {
    }

    registerProducts(products: Array<string>) {

        products.forEach((productId) => {
            this.store.register({
                id: productId,
                type: this.store.PAID_SUBSCRIPTION
            });
        });

    }

    setupStoreListeners(products: Array<string>, validate: boolean = false) {

        this.presentLoader();

        this.ownedProducts = [];

        if (validate) {
            this.store.validator = 'https://validator.fovea.cc/v1/validate?appName=sympto.stars&apiKey=b8262259-4a6d-4f23-994e-9691ce9a7859';
        }

        for (let i = 0; i < products.length; i++) {
            // updated
            const self = this.store;
            this.store.when(products[i]).updated((product: IAPProduct) => {
                console.log('### updated: ', product);

                this.dismissLoader();

                if (product.loaded && product.valid && product.state === self.APPROVED && product.transaction != null) {
                    console.log('------- ### updated finished ### -------: ', product);
                    // Produkt wurde gekauft bzw. aktualisiert (z.B. neuer Abrechnungszeitraum)
                    product.finish();
                }

                if (!product.owned) {
                    this.msgService.sendMessage({context: 'iap:subscribed', value: false, subscription: product});
                } else {
                    this.msgService.sendMessage({context: 'iap:subscribed', value: true, subscription: product});
                    this.ownedProducts.push(product);
                }

                // last loop
                if (i === products.length - 1) {
                    setTimeout(() => {
                        if (this.ownedProducts.length < 1) {
                            this.router.navigate(['/pay-wall']).then(() => {
                                // this.presentConfirmToast();
                            });
                        }
                    }, 5000);
                }


            });

            // registered
            this.store.when(products[i]).registered((product: IAPProduct) => {
                console.log('### registered: ', product);
            });

            // owned
            this.store.when(products[i]).owned((product: IAPProduct) => {
                console.log('### owned: ', product);
            });

            // approved
            this.store.when(products[i]).approved((product: IAPProduct) => {
                console.log('### approved: ', product);
            });

            // refunded
            this.store.when(products[i]).refunded((product: IAPProduct) => {
                console.log('### refunded: ', product);
            });

            // expired
            this.store.when(products[i]).expired((product: IAPProduct) => {
                console.log('### expired: ', product);
            });

            // loaded
            this.store.when(products[i]).loaded((product: IAPProduct) => {
                console.log('### loaded: ', product);
            });

            // valid
            this.store.when(products[i]).valid((product: IAPProduct) => {
                console.log('### valid: ', product);
            });

            // invalid
            this.store.when(products[i]).invalid((product: IAPProduct) => {
                console.log('### invalid: ', product);
            });

        }
    }

    purchase(product: IAPProduct) {
        this.store.order(product).then(p => {
            // Purchase in progress!
            console.log('purchase: ', p);
        }, (e) => {
            console.log('Failed', 'Failed to purchase: ', e);
        });
    }

    async presentConfirmToast() {
        const options: any = {
            message: 'Purchase expired!',
            position: 'middle',
            cssClass: 'sympto-validation-error-toast',
            buttons: [{
                text: 'OK',
                handler: () => {

                }
            }]
        };
        const toast = await this.toastCtrl.create(options);
        await toast.present();

        await toast.onDidDismiss().then(() => {

        });
    }

    refresh() {
        this.platform.ready().then(() => {
            console.log('### REFRESH ###');
            this.presentLoader()
            this.store.refresh();
        });
    }

    async presentLoader(msg: string = '') {
        this.loader = await this.loadingCtrl.create({
            message: msg,
            duration: 10000
        });
        await this.loader.present();
    }

    async dismissLoader() {
        if (this.loader != null) {
            await this.loadingCtrl.dismiss();
            this.loader = null;
        }
        return;
    }

}

// https://medium.com/bewizyu/in-app-purchase-with-ionic-cordova-18960239f989

// https://stackoverflow.com/questions/61030112/how-to-control-cancel-subscribe-ionic-in-app-purchase


